import React from 'react';
import PropTypes from 'prop-types';

import UserAvatar from '../UserAvatar';

import EmailIcon from '../../assets/images/email-blue-button.svg';
import PhoneIcon from '../../assets/images/phone-icon-blue.svg';
import SMSIcon from '../../assets/images/sms-icon-blue.svg';
import './MultipleUserPopup.scss';

export default class MultipleUserPopup extends React.Component {

  constructor(props) {
    super(props);
    MultipleUserPopup.propTypes = {
      handleCloseClicked: PropTypes.func,
      isMobile: PropTypes.bool,
      title: PropTypes.string,
      users: PropTypes.arrayOf(PropTypes.object).isRequired,
    };
    MultipleUserPopup.defaultProps = {
      title: 'Users',
      isMobile: false,
    };
    this.openContactUrl = this.openContactUrl.bind(this);
    this.handleCloseClicked = this.handleCloseClicked.bind(this);
  }

  componentDidMount() {
    this.handleClickOutside = event => {
      if (this.componentRef && !this.componentRef.contains(event.target)) this.props.handleCloseClicked();
    };
    document.addEventListener('click', this.handleClickOutside, false);
  }
  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside, false);
  }

  openContactUrl(contactUrl) {
    if (this.props.isMobile) {
      window.open(contactUrl, '_system');
    }
    else window.location = contactUrl;
  }

  handleCloseClicked(e) {
    e.stopPropagation();

    const { handleCloseClicked } = this.props;
    if (handleCloseClicked) {
      handleCloseClicked();
    }
  }

  render() {
    const {
      users,
      title,
      isMobile,
      trianglePosition,
      popupTopPosition,
      popupLeftPosition,
    } = this.props;

    let style;
    if (popupTopPosition && popupLeftPosition) {
      style = { position: 'fixed', top: popupTopPosition, left: popupLeftPosition };
    }

    const userCards = users.map(user => {
      if (user) {
        //shouldn't be here? expand user is not a function
        const expandedUser = user; // dataModel.usersDAO.expandUser(user)
        const userName = expandedUser.name || (expandedUser.first_name + ' ' + expandedUser.last_name);
        const userCompany = expandedUser.companies ? expandedUser.companies[0].name : null;

        const contactIcons = [];
        if (isMobile && expandedUser.phone) {
          contactIcons.push(<img src={SMSIcon} alt='send message' onClick={() => this.openContactUrl('sms://' + expandedUser.phone)} key={expandedUser.id + '-sms'} />);
          contactIcons.push(<img src={PhoneIcon} alt='call' onClick={() => this.openContactUrl('tel:' + expandedUser.phone)} key={expandedUser.id + '-phone'} />);
        }
        contactIcons.push(<img src={EmailIcon} alt='email' onClick={() => this.openContactUrl('mailto:' + expandedUser.email)} key={expandedUser.id + '-email'} />);

        return <div className='user-info' key={user.id}>
          <div id='avatar-wrapper'><UserAvatar user={expandedUser} larger={true} /></div>
          <div className='user-info__name-and-company'>
            <span className='name'>{userName}</span>
            <span className='company'>{userCompany}</span>
          </div>
          <div className='user-info__contact-icons'>
            {contactIcons}
          </div>
        </div>;
      }
      return null;
    });

    return (
      <div className={'multi-user-popup' + (isMobile ? ' multi-user-popup--mobile' : '')} ref={el => this.componentRef = el} style={style}>
        <div className={'multi-user-popup__triangle' + (trianglePosition == 'left' ? ' multi-user-popup__triangle--left' : (trianglePosition == 'right' ? ' multi-user-popup__triangle--right' : ''))} />
        <span className='multi-user-popup__title'>{title}</span>
        <span className='multi-user-popup__x' onClick={this.handleCloseClicked}>&times;</span>
        <div className='multi-user-popup__users'>
          {userCards}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/MultipleUserPopup/index.js